module.exports = __webpack_public_path__ + "static/media/Rubik-Light.5397cb7c.woff";